import { render } from "./DepartmentPrompts.vue?vue&type=template&id=3d5c1b9e&scoped=true"
import script from "./DepartmentPrompts.vue?vue&type=script&lang=js"
export * from "./DepartmentPrompts.vue?vue&type=script&lang=js"

import "./DepartmentPrompts.vue?vue&type=style&index=0&id=3d5c1b9e&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c1b9e"]])

export default __exports__